import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompLanding } from './clergycomp-landing';
import { CurrentContext } from '../models';


export function ClergyCompReportContent() {
	const context = useSelector<TcsmStates, CurrentContext>(state => state.clergyCompReportState.currentContext);
	switch (context) {
		case CurrentContext.LANDING:
			return <ClergyCompLanding />;
		default:
			return null;
	}
}